import { Link } from 'react-router-dom';
import { featuredCategories, allCategoryButtons, categoryButtonImages } from '@/mocks/siteData';

export default function PopularCategories() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            Shop by Category
          </h2>
          <p className="mt-3 text-foreground-600 text-base max-w-md mx-auto">
            Browse our curated product categories sourced through the itaobuy spreadsheet system
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden hover:border-foreground-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/5] overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={`Itaobuy spreadsheet ${cat.name} category - browse curated products`}
                  title={`Itaobuy Spreadsheet ${cat.name} Category`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                  {cat.name}
                </h3>
                <p className="mt-1 text-sm text-foreground-500">{cat.count}</p>
                <span className="inline-flex items-center gap-1.5 mt-3 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  Explore Category
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-16">
          <h3 className="font-heading text-2xl font-semibold text-foreground-950 text-center mb-8">
            More Categories
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {allCategoryButtons.map((cat) => {
              const imgSrc = categoryButtonImages[cat.name];
              return (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="group flex flex-col items-center rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden hover:border-foreground-300 transition-all duration-300 cursor-pointer"
                >
                  {imgSrc ? (
                    <div className="w-full aspect-square overflow-hidden bg-background-100">
                      <img
                        src={imgSrc}
                        alt={`Itaobuy spreadsheet ${cat.name} category`}
                        title={`Itaobuy Spreadsheet ${cat.name}`}
                        className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-400"
                      />
                    </div>
                  ) : (
                    <div className="w-full aspect-square flex items-center justify-center bg-background-100">
                      <i className="ri-store-2-line w-8 h-8 flex items-center justify-center text-foreground-400"></i>
                    </div>
                  )}
                  <div className="py-3 px-2 w-full text-center">
                    <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                      {cat.name}
                    </span>
                  </div>
                </a>
              );
            })}
          </div>
          <div className="mt-8 text-center">
            <Link
              to="/article/what-is-itaobuy-spreadsheet"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-primary-200 bg-primary-50 text-sm font-medium text-primary-700 hover:bg-primary-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              View All Categories
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}